module.exports = __webpack_public_path__ + "static/media/IconDownload.b00e7ea5.svg";